import { lazy } from 'react'

export const UpdateClientModalAsync = lazy(() =>
    import('./UpdateClientModal').then((module) => ({
        default: module.UpdateClientModal,
    }))
)
